import styled from 'styled-components';

const LoaderContainer = styled.div`
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ModalForm = styled.form`
  display: flex;
  flex-direction: column;
`;

const TableContainer = styled.div`
  overflow-x: auto;
`;

export { LoaderContainer, HeaderContainer, ModalForm, TableContainer };
